import { addLog } from "../stores/LoggerStore";
export const Broom = (procmgr) => {
    const transition = 0.5;
    // const transition = 5;
    const broomTransition = 2;
    const desktop = document.querySelector("#desktop");
    const swiper = document.querySelector("#broom-swiper") ||
        document.createElement("span");
    const broom = document.querySelector("#broom-image");
    swiper.id = "broom-swiper";
    swiper.style.position = "fixed";
    swiper.style.width = "0%";
    swiper.style.height = "100%";
    swiper.style.top = "0%";
    swiper.style.left = "0%";
    // swiper.style.backgroundColor='lime';
    swiper.style.background =
        "linear-gradient(135deg, #b4d9dd 25%, #eec768 60%, #dc8279)";
    swiper.style.opacity = "0.5";
    swiper.style.transition = `${transition}s`;
    desktop.appendChild(swiper);
    setTimeout(() => {
        swiper.style.width = "100%";
        swiper.style.height = "100%";
        broom.classList.add("active");
    }, 1);
    setTimeout(() => {
        swiper.style.left = "100%";
        swiper.style.right = "0%";
        swiper.style.width = "0%";
    }, transition * 1000);
    setTimeout(() => {
        broom.classList.remove("active");
    }, 1000);
    procmgr.killAll();
    addLog("BROOOOM");
};
